import React from 'react';
import { motion } from 'framer-motion';
import { Eyebrow, EASE } from '../ui/Primitives';
export function PageHeader({
  eyebrow,
  title,
  sub
}: {
  eyebrow: string;
  title: string;
  sub?: string;
}) {
  return <section className="relative overflow-hidden border-b border-espresso/10 bg-sand/40 px-5 py-16 sm:px-8 lg:px-10 lg:py-24" data-id="element-82" data-mp="isq70ht30i9">
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-champagne/40 blur-3xl" data-id="element-83" data-mp="5bvcqoo619oy" />
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: EASE
    }} className="relative z-10 mx-auto w-full max-w-6xl" data-id="element-84" data-mp="eah1j1k8dky6">
        <Eyebrow data-id="element-85" data-mp="o83l41ch60oh">{eyebrow}</Eyebrow>
        <h1 className="mt-5 max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight text-espresso sm:text-5xl lg:text-[3.5rem]" data-id="element-86" data-mp="o7283rbwf444">
          {title}
        </h1>
        {sub && <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-espresso/60 lg:text-lg" data-id="element-87" data-mp="2q2vukzahpz7p">
            {sub}
          </p>}
      </motion.div>
    </section>;
}